import apiConfig from "../../apiConfig";

export const deleteDonationSide = async (at, donationSideId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Delete_Donation_Side",
		{
			Donation_Side_Id: donationSideId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	// if (response.data.Status) {
	// 	return response.data;
	// }

	// return [];
	return response.data;
};
